import getDefaultOpts from "@/store/utils/getDefaultOpts.js";

async function patchEntity(patch, categoryID, entryID, opts, dispatch) {
  if (!categoryID && !entryID) {
    await dispatch("patchSite", {
      patch,
      opts,
    });
  } else if (!entryID) {
    await dispatch("patchCategory", {
      path: `/category/${categoryID}`,
      patch,
      opts,
    });
  } else {
    await dispatch("patchEntry", {
      categoryID,
      path: `/entry/${entryID}`,
      patch,
      opts,
    });
  }
}

async function setStoreVar(value, key, dispatch) {
  const payload = {
    page: key[0],
    group: key[1],
    type: key[2],
    name: key[3],
    value,
  };
  await dispatch("setStoreVar", payload, { root: true });
}

const patchEntityMedia = async (
  module,
  { media, dataKey, categoryID, entryID, opts = {} }
) => {
  const { dispatch } = module;
  const config = Object.assign(getDefaultOpts(), opts);
  await setStoreVar(media, dataKey, dispatch);
  await patchEntity(
    {
      [dataKey[3]]: media,
    },
    categoryID,
    entryID,
    config,
    dispatch
  );
};

export { patchEntityMedia };
